import { render, staticRenderFns } from "./activity-workshop-game.vue?vue&type=template&id=55129f6f&scoped=true&"
import script from "./activity-workshop-game.vue?vue&type=script&lang=js&"
export * from "./activity-workshop-game.vue?vue&type=script&lang=js&"
import style0 from "./activity-workshop-game.vue?vue&type=style&index=0&id=55129f6f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55129f6f",
  null
  
)

export default component.exports